import { createContext, useContext } from "react";

interface TransportOrderFormContextType {
  initialValue: any;
  otData: any;
  handleNext: () => void;
  setOtData: (data: any) => void;
  onRefetch?: () => void;
  handlePrev: () => void;
  onFinish: (values?: any) => void;
}

export const TransportOrderFormContext = createContext<
  TransportOrderFormContextType | undefined
>(undefined);

export const useTransportOrderForm = (): TransportOrderFormContextType => {
  const context = useContext(TransportOrderFormContext);
  if (!context) {
    throw new Error(
      "useTransportOrderForm must be used within a TransportOrderFormContext.Provider"
    );
  }
  return context;
};
